import React, { useState, useEffect } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import '../styles/WishlistButton.css';

const WishlistButton = ({ productId }) => {
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [isLoggedIn] = useState(!!localStorage.getItem('token'));

  useEffect(() => {
    // Check if item is in wishlist on load
    const checkWishlist = async () => {
      if (!isLoggedIn) {
        return;
      }

      try {
        const response = await fetch(`/api/wishlist/check/${productId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        setIsInWishlist(data.inWishlist);
      } catch (error) {
        // Error will be handled by the global error handler
      }
    };

    checkWishlist();
  }, [productId, isLoggedIn]);

  const toggleWishlist = async e => {
    e.stopPropagation(); // Prevent event bubbling to parent elements

    if (!isLoggedIn) {
      // Redirect to login
      window.location.href = '/auth?returnTo=' + encodeURIComponent(window.location.pathname);
      return;
    }

    try {
      const method = isInWishlist ? 'DELETE' : 'POST';
      const url = isInWishlist ? `/api/wishlist/remove/${productId}` : '/api/wishlist/add';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: isInWishlist ? null : JSON.stringify({ product_id: productId }),
      });

      if (response.ok) {
        setIsInWishlist(!isInWishlist);
      }
    } catch (error) {
      // Error will be handled by the global error handler
    }
  };

  return (
    <button
      className={`wishlist-button ${isInWishlist ? 'active' : ''}`}
      onClick={toggleWishlist}
      aria-label={isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
    >
      {isInWishlist ? <FaHeart /> : <FaRegHeart />}
    </button>
  );
};

export default WishlistButton;
